import { jsx as r } from "react/jsx-runtime";
const e = ({
  size: L
}) => {
  switch (L) {
    case "sm":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M6.36667 11.7692L2.81033 8.21284L3.523 7.5L6.36667 10.3437L12.477 4.23334L13.1897 4.94617L6.36667 11.7692Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M9.55002 17.6538L4.21552 12.3193L5.28452 11.25L9.55002 15.5155L18.7155 6.35001L19.7845 7.41926L9.55002 17.6538Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M7.95833 14.7114L3.51291 10.266L4.40374 9.37499L7.95833 12.9296L15.5962 5.29166L16.4871 6.1827L7.95833 14.7114Z",
          fill: "currentColor"
        }
      );
  }
}, c = ({
  size: L
}) => {
  switch (L) {
    case "sm":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M6.36666 12.1275L2.43916 8.2L3.52066 7.1185L6.36666 9.9645L12.4793 3.85184L13.5608 4.93334L6.36666 12.1275Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M9.55 18.1912L3.65875 12.3L5.281 10.6777L9.55 14.9467L18.719 5.77774L20.3413 7.39999L9.55 18.1912Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M7.95834 15.1594L3.04897 10.25L4.40084 8.89812L7.95834 12.4556L15.5992 4.81479L16.951 6.16666L7.95834 15.1594Z",
          fill: "currentColor"
        }
      );
  }
}, o = ({
  size: L = "md",
  weight: t = "default"
}) => {
  switch (t) {
    case "bold":
      return /* @__PURE__ */ r(c, { size: L });
    case "book":
    case "default":
      return /* @__PURE__ */ r(e, { size: L });
  }
};
export {
  o as default
};
//# sourceMappingURL=DIconCheck.js.map
